/* eslint-disable no-undef */
import $ from "jquery";

const addToCart = () => {
    const init = () => {
        ajax();
    };

    const ajax = () => {
        $(document).on("click", ".js-btn-add-to-cart", function () {
            //you can change the event listener and the selector as you wish
            const thisEl = $(this);
            const data = {
                action: themeObj.shop.action.add_to_cart,
                nonce: themeObj.shop.nonce,
                product_id: $(this).data("id"),
            };

            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: data,
            })
                .done(() => {
                    window.location.href = thisEl.data("redirect");
                })
                .fail((response) => {
                    console.error(response);
                });
        });
    };

    init();
};

try {
    addToCart();
} catch (error) {
    console.error("addToCart", error);
}
